// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__kK7le","disabled":"FileBtn_disabled__k81I0","warn":"FileBtn_warn__2Ijhf","fade":"FileBtn_fade__3Jqqs"};